<script>
export default {
  name: "invitationDetails",
  props: {
    rowData: {
      type: Object,
      default: () => {
      }
    }
  },
  data() {
    return {

      customOptions: {
        // 请求的列表url
        url: "/api/v1/manage/invitation/record",
        // 请求的参数列表
        params: {
          page: 1, // 页数
          size: 20, // 每页条数
          id: this.rowData.id
        },
        search: [
          {type: "input", field: "inviterDriverPhone", name: "邀请人电话", value: ""},
          {type: "input", field: "inviteeDriverPhone", name: "被邀请人电话", value: ""},
        ],
      },
      // 表头
      columns: [
        {prop: "inviterDriverName", label: "邀请人", width: 100},
        {prop: "inviterDriverPhone", label: "邀请人电话", width: 140},
        {prop: "inviteeDriverName", label: "被邀请人", width: 100},
        {prop: "inviteeDriverPhone", label: "被邀请人电话", width: 140},
        {prop: "created", label: "邀请时间"},
        {prop: "finishTime", label: "奖励发放时间"},
        {prop: "driverStatus", label: "被邀请人账号状态"}
      ],
    }
  }
}
</script>

<template>
  <div class="invitationDetails">
    <div class="orderContent">
      <div class="formTitle">活动详情{{ rowData.invitationNo }}/ {{
          rowData.status | filterConst('INVITATIONTYPE')
        }}
      </div>
      <div style="height: 12px"></div>

      <el-form label-position="left" label-width="115px">
        <div class="formContent">
          <div class="items">
            <el-form-item label="开始时间">
              <span class="color-666"> {{ rowData.validityStartTime | filterTime }}</span>
            </el-form-item>
          </div>
          <div class="items">
            <el-form-item label="结束时间">
              <span class="color-666">{{ rowData.validityEndTime | filterTime }}</span>
            </el-form-item>
          </div>
          <div class="items">
            <el-form-item label="作废时间">
              <span class="color-666">{{ rowData.cancellationTime |  filterTime }}</span>
            </el-form-item>
          </div>
          <div class="items">
            <el-form-item label="邀请人奖励">
              <span class="color-666">{{ rowData.inviterAmount || 0 }}元/次 <span >累计发放{{ rowData.inviterGetTotalAmount || 0 }}元</span></span>
            </el-form-item>
          </div>
          <div class="items">
            <el-form-item label="被邀请人奖励">
              <span class="color-666" v-if="rowData.inviteeAmount">{{ rowData.inviteeAmount || 0 }}元/人 <span
                  v-if="rowData.inviteeGetTotalAmount">累计发放{{ rowData.inviteeGetTotalAmount || 0 }}元</span> </span>
              <span v-else>-</span>
            </el-form-item>
          </div>
          <div class="items">
            <el-form-item label="累计邀请">
              <span class="color-666">{{ rowData.validityNum || 0 }}人</span>
            </el-form-item>
          </div>
          <div class="items">
            <el-form-item label="累计发放总金额">
              <span class="color-666"> {{
                  ((rowData.inviteeGetTotalAmount || 0) + (rowData.inviterGetTotalAmount || 0)) | filterMoney
                }}元</span>
            </el-form-item>

          </div>
          <div class="items">
            <el-form-item label="奖池金额">
              <span class="color-666"> {{(rowData.prizePoolAmount || 0)  }} 元/ 剩余{{ ((rowData.prizePoolAmount || 0) - ( (rowData.inviteeGetTotalAmount || 0) + (rowData.inviterGetTotalAmount || 0))) | filterMoney }}元</span>
            </el-form-item>

          </div>

        </div>


      </el-form>

      <div class="formTitle">活动记录</div>
      <div style="height: 12px"></div>
      <div>
        <custom-table excel-type="DriverInvitation" :has-organization="false" ref="customTable"
                      :customOptions="customOptions" :columns="columns"
                      labelWidth="135" style="height: 500px">
          <template slot-scope="{ item, row }">
            <template v-if="['created','finishTime'].includes(item.prop)">
              {{ row[item.prop] | filterTime }}
            </template>
            <template v-else-if="['inviterDriverName', 'inviteeDriverName'].includes(item.prop)">
              <span @dblclick="$utils.dblclickCopy">{{ row[item.prop] }}</span>
            </template>
            <template v-else-if="['inviterDriverPhone', 'inviteeDriverPhone'].includes(item.prop)">
              <span @dblclick="$utils.dblclickCopy">{{ row[item.prop] }}</span>
            </template>
            <template v-else-if="item.prop == 'driverStatus'">
              {{ row.driverStatus | filterConst('DRIVERSTATUS') }}
            </template>


            <template v-else>{{ row[item.prop] ? row[item.prop] : "-" }}</template>
          </template>
        </custom-table>
      </div>
    </div>
  </div>
</template>

<style scoped lang="less">
.invitationDetails {
  .formContent {
    display: flex;
    flex-wrap: wrap;

    .items {
      width: 32%;
      margin-right: 1%;
      word-wrap: break-word; /* 旧版浏览器支持 */
      overflow-wrap: break-word; /* 标准属性 */
    }


  }
}


</style>